'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserExperimentVariationMap = exports.getCohortForExperiment = exports.trackOptimizelyEvent = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

exports.isActiveExperimentById = isActiveExperimentById;
exports.isActiveExperimentByName = isActiveExperimentByName;
exports.isActiveVariationById = isActiveVariationById;
exports.isActiveVariationByName = isActiveVariationByName;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-underscore-dangle, import/prefer-default-export */

function experimentById(experimentId) {
  try {
    return window.optimizely.get('state').getExperimentStates()[experimentId];
  } catch (err) {/* NOOP */}
}

function experimentByName(experimentName) {
  try {
    var userState = window.optimizely.get('state').getExperimentStates();
    return (0, _values2.default)(userState).find(function (experiment) {
      return (experiment.experimentName || '').startsWith(experimentName);
    });
  } catch (err) {/* NOOP */}
}

var trackOptimizelyEvent = exports.trackOptimizelyEvent = function trackOptimizelyEvent(name) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  /* istanbul ignore next */
  if (__CLIENT__) {
    window.optimizely = window.optimizely || [];
    window.optimizely.push(['trackEvent', name, metadata].filter(Boolean));
  }
};

var getCohortForExperiment = exports.getCohortForExperiment = function getCohortForExperiment(experimentPrefix) {
  var experiment = experimentByName(experimentPrefix) || {};
  if (experiment.isActive) {
    return {
      test_id: experiment.id,
      variant_id: experiment.variation.id,
      experiment_name: experiment.experimentName,
      variation_name: experiment.variation.name,
      test_branch: experiment.experimentName + ': ' + experiment.variation.name
    };
  }
};

var getUserExperimentVariationMap = exports.getUserExperimentVariationMap = function getUserExperimentVariationMap() {
  try {
    var userState = window.optimizely.get('state').getExperimentStates();
    return (0, _values2.default)(userState).filter(function (_ref) {
      var variation = _ref.variation;
      return variation;
    }).reduce(function (memo, _ref2) {
      var experimentName = _ref2.experimentName,
          variation = _ref2.variation;
      return memo[experimentName] = variation.name, memo;
    }, {});
  } catch (err) {
    return {};
  }
};

function isActiveExperimentById(experimentId) {
  var experiment = experimentById(experimentId) || {};
  return !!experiment.isActive;
}

function isActiveExperimentByName(experimentName) {
  var experiment = experimentByName(experimentName) || {};
  return !!experiment.isActive;
}

function isActiveVariationById(experimentId, variationId) {
  var experiment = experimentById(experimentId) || {};
  return !!(experiment.isActive && experiment.variation.id === variationId);
}

function isActiveVariationByName(experimentName, variationName) {
  var experiment = experimentByName(experimentName) || {};
  return !!(experiment.isActive && experiment.variation.name === variationName);
}